import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const i = ({
  title: e,
  titleId: o,
  ...s
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m811.503 478.91-1.856 6.827c-1.835 6.763-4.075 13.077-6.4 19.243l-2.667 6.699c-29.973 70.187-91.477 96.341-190.635 107.264 32.107 21.589 41.365 48.683 41.365 121.984 0 73.323-.917 83.285-.747 100.053.363 27.691 38.336 40.96 36.949 49.835-1.408 8.896-31.808 7.445-46.08 2.219-40.277-14.912-36.245-50.688-36.245-50.688l-1.28-98.133s2.731-52.715-15.595-52.715V852.01c0 34.901 23.061 45.419 23.061 58.411 0 22.08-41.92-2.048-54.827-16-19.563-21.035-17.408-65.621-16.939-100.885.469-34.091-.277-108.608-.277-108.608l-13.269.341s5.376 162.773-7.061 192.384c-16.192 38.037-64.96 51.243-64.96 33.835 0-11.691 12.053-8 18.688-34.112 5.611-22.208 3.776-188.181 3.776-188.181s-15.637 9.877-15.637 40.96c0 14.165-.32 95.509-.32 119.616 0 30.464-40.576 47.744-60.053 47.744-9.877 0-22.101-.533-22.101-6.08 0-14.059 36.992-22.315 36.992-51.605 0-25.344-.469-90.645-.469-90.645s-18.688 3.392-45.355 3.392c-67.115 0-88.32-45.632-98.453-71.211-13.163-33.344-30.251-48.939-48.32-61.547-11.179-7.659-13.653-16.661-.789-19.221 59.392-11.968 74.539 71.829 114.389 85.163 28.181 9.557 64.64 5.483 82.795-7.083 2.411-25.536 19.691-47.744 34.155-59.392-101.013-10.304-160.917-47.744-191.808-107.925l-3.392-6.677c-2.944-6.208-5.504-12.48-7.829-19.072l-2.304-6.784c-9.728-30.571-14.016-65.557-14.016-104.64 0-69.291 20.181-95.509 47.381-132.331-20.8-78.912 7.467-133.035 7.467-133.035s43.691-9.728 126.315 53.355c44.843-20.352 164.245-22.059 220.651-4.48 34.624-24.491 98.048-59.093 123.733-49.344 6.848 11.819 21.803 46.549 8.917 122.645 8.768 16.811 53.845 52.331 54.08 152.896-.747 37.163-4.395 68.459-11.029 95.019z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = c(i);
export {
  n as default
};
